import { FC } from 'react';
import { DataCellProps } from '../types';

export const TeamMemberEmailCell: FC<DataCellProps> = ({ _customRowProps, member }) => {
  return <div>{member.email}</div>;
};
